const REGEXES = [
  // This format is displayed when Twilio immediately returns with an error when
  // the backend sends the delivery.
  /(twilio error )(\d+)(.*)/i,
  // This format is displayed when Twilio notifies the Edge API about a failure
  // (bounce) later.
  // See https://github.com/customerio/services/blob/fb8e1de193ed7660fedcc39c7c623995d2e5bd5d/src/customerio/edge_api/serve/twilio.go#L79
  /(twilio error code: )(\d+)(.*)/i,
];

function extractErrorKey(error) {
  let key = '';
  if (typeof error === 'string') {
    key = error;
  } else if (error?.detail) {
    key = error.detail;
  }
  return key;
}

export default function twilioFormatter(error) {
  let errorKey = extractErrorKey(error);
  let matchedRegex = REGEXES.find((regex) => regex.test(errorKey));

  if (!matchedRegex) {
    return errorKey;
  }

  let [, prefix, code, suffix] = errorKey.match(matchedRegex);

  return `<a href="https://www.twilio.com/docs/api/errors/${code}" target="_blank" rel="nofollow">${prefix}${code}</a>${suffix}`;
}
